<template>
  <div class="device-cards">
    <!-- 第一行：电表、光伏、充电桩 -->
    <div class="cards-row" v-if="false">
      <!-- 电表卡片 -->
      <div class="device-card card-tall" @click="openMeterDetail">
        <div class="card-bg"></div>
        <div class="card-header">
          <img :src="require('@/assets/images/station-monitor/image_51.png')" class="card-icon" />
          <span class="card-title">电表</span>
          <img :src="require('@/assets/images/station-monitor/image_52.png')" class="arrow-icon" />
        </div>
        <div class="card-content">
          <div class="info-item">
            <span class="label">关口表数量：</span>
            <span class="value">{{ meterData.pcc }}</span>
          </div>
          <div class="info-item">
            <span class="label">并网表数量：</span>
            <span class="value">{{ meterData.gcp }}</span>
          </div>
          <div class="info-item">
            <span class="label">负载表数量：</span>
            <span class="value">{{ meterData.load }}</span>
          </div>
        </div>
      </div>

      <!-- 光伏卡片 -->
      <div class="device-card card-tall" :class="{ 'device-card-disabled': !props.hasPvData }">
        <div class="card-bg bg-pv"></div>
        <div class="card-header">
          <img :src="require('@/assets/images/station-monitor/image_54.png')" class="card-icon icon-pv" />
          <span class="card-title">光伏</span>
          <img :src="require('@/assets/images/station-monitor/image_55.png')" class="arrow-icon" />
        </div>
        <template v-if="props.hasPvData">
          <div class="card-content">
            <div class="info-item">
              <span class="label">总有功功率：</span>
              <span class="value">{{ pvData.totalPower }}kW</span>
            </div>
            <div class="info-item">
              <span class="label">日发电量：</span>
              <span class="value">{{ pvData.dailyGeneration }}kWh</span>
            </div>
            <div class="info-item">
              <span class="label">发电总量：</span>
              <span class="value">{{ pvData.totalGeneration }}kWh</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="no-data-overlay">
            <p class="no-data-text">暂无光伏设备</p>
            <!-- <div class="learn-more-btn">
              <a href="#" class="learn-more-link">了解奇点方案</a>
            </div> -->
          </div>
        </template>
      </div>

      <!-- 充电桩卡片 -->
      <div class="device-card card-tall" :class="{ 'device-card-disabled': !props.hasChargerData }">
        <div class="card-bg bg-charger"></div>
        <div class="card-header">
          <img :src="require('@/assets/images/station-monitor/image_57.png')" class="card-icon icon-charger" />
          <span class="card-title">充电桩</span>
          <img :src="require('@/assets/images/station-monitor/image_58.png')" class="arrow-icon" />
        </div>
        <template v-if="props.hasChargerData">
          <div class="card-content">
            <div class="info-item">
              <span class="label">总充电功率：</span>
              <span class="value">{{ chargerData.totalChargePower }}kW</span>
            </div>
            <div class="info-item info-item-light">
              <span class="label">充电桩数量：</span>
              <span class="value">{{ chargerData.chargerCount }}</span>
            </div>
            <div class="info-item">
              <span class="label">总额定功率：</span>
              <span class="value">{{ chargerData.totalRatedPower }}kW</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="no-data-overlay">
            <p class="no-data-text">暂无充电桩设备</p>
            <!-- <div class="learn-more-btn">
              <a href="#" class="learn-more-link">了解奇点方案</a>
            </div> -->
          </div>
        </template>
      </div>
    </div>

    <!-- 第二行：变压器、消防、热管理 -->
    <div class="cards-row cards-row-short ">
      

      <!-- 消防卡片 -->
      <div class="device-card card-short" @click="openFireDetail">
        <div class="card-bg-white"></div>
        <div class="card-overlay">
          <img :src="require('@/assets/images/station-monitor/image_61.png')" class="card-icon icon-fire" />
          <span class="card-title">消防</span>
          <img :src="require('@/assets/images/station-monitor/image_62.png')" class="arrow-icon" />
        </div>
      </div>

      <!-- 热管理卡片 -->
      <div class="device-card card-short" @click="openThermalManagementDetail">
        <div class="card-bg-white"></div>
        <div class="card-overlay">
          <img :src="require('@/assets/images/station-monitor/image_63.png')" class="card-icon" />
          <span class="card-title">热管理</span>
          <img :src="require('@/assets/images/station-monitor/image_64.png')" class="arrow-icon" />
        </div>
      </div>
      
      <!-- 变压器卡片 -->
      <div class="device-card card-short device-card-disabled">
        <div class="card-bg-white"></div>
        <div class="card-overlay">
          <img :src="require('@/assets/images/station-monitor/image_59.png')" class="card-icon" />
          <span class="card-title">变压器</span>
          <img :src="require('@/assets/images/station-monitor/image_60.png')" class="arrow-icon" />
        </div>
      </div>
    </div>
  </div>

  <!-- 热管理详情弹框 -->
  <ThermalManagementDetailDialog v-model="thermalManagementDialogVisible" />

  <!-- 消防详情弹框 -->
  <FireDetailDialog v-model="fireDetailDialogVisible" />

  <!-- 电表详情弹框 -->
  <MeterDetailDialog v-model="meterDetailDialogVisible" />
</template>

<script setup>
import { computed, ref } from 'vue'
import ThermalManagementDetailDialog from './ThermalManagementDetailDialog.vue'
import FireDetailDialog from './FireDetailDialog.vue'
import MeterDetailDialog from './MeterDetailDialog.vue'
 
// 接收props
const props = defineProps({
  hasPvData: {
    type: Boolean,
    default: false
  },
  hasChargerData: {
    type: Boolean,
    default: false
  },
  diagramData: {
    type: Object,
    default: () => ({})
  }
})

// 电表数据
const meterData = computed(() => {
  const meter = props.diagramData?.meter || {}
  return {
    pcc: meter.pcc ?? '--',
    gcp: meter.gcp ?? '--',
    load: meter.load ?? '--'
  }
})

// 光伏数据
const pvData = computed(() => {
  const pv = props.diagramData?.pv || {}
  return {
    totalPower: pv.p ?? '--',
    dailyGeneration: pv.power_gen_d ?? '--',
    totalGeneration: pv.sum_power_gen ?? '--'
  }
})

// 充电桩数据
const chargerData = computed(() => {
  const charger = props.diagramData?.chargePile || {}
  return {
    totalChargePower: charger.total_power ?? '--',
    chargerCount: charger.count ?? '--',
    totalRatedPower: charger.rated_power ?? '--' // 后端未提供此字段
  }
})

// 热管理详情弹框
const thermalManagementDialogVisible = ref(false)

const openThermalManagementDetail = () => {
  thermalManagementDialogVisible.value = true
}

// 消防详情弹框
const fireDetailDialogVisible = ref(false)

const openFireDetail = () => {
  fireDetailDialogVisible.value = true
}

const meterDetailDialogVisible = ref(false)

const openMeterDetail = () => {
  meterDetailDialogVisible.value = true
}
</script>

<style scoped lang="scss">
.device-cards {
  width: 100%;
  /* 改为100%以适应父容器 */
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cards-row {
  display: flex;
  gap: 15px;
}

.cards-row-short {
  margin-top: 0;
}

.device-card {
  position: relative;
  flex: 1;
  /* 自适应宽度 */
  min-width: 0;
  /* 允许压缩 */
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }

  &.device-card-disabled {
     filter: grayscale(80%);
     opacity: 0.8;
     pointer-events: none;
  }
}

.card-tall {
  height: 166px;
}

.card-short {
  height: 68px;
}

.card-bg,
.card-bg-white {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 68px;
  background-image: url('@/assets/images/station-monitor/image_50.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.bg-pv {
  background-image: url('@/assets/images/station-monitor/image_53.png');
}

.bg-charger {
  background-image: url('@/assets/images/station-monitor/image_56.png');
}

.card-bg-white {
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
}

.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 68px;
  background: linear-gradient(104deg, rgba(231, 237, 255, 0.4) 0.38%, rgba(255, 255, 255, 0.4) 99.52%);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.card-header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 68px;
}

.card-icon {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
}

.icon-pv {
  width: 34px;
  height: 30px;
}

.icon-charger {
  width: 26px;
  height: 28px;
}

.icon-fire {
  width: 19px;
  height: 28px;
}

.card-title {
  margin-left: 12px;
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 16px;
  color: rgba(46, 46, 46, 1);
  font-weight: 400;
  line-height: normal;
  flex: 1;
}

.arrow-icon {
  width: 10px;
  height: 10px;
  margin-left: auto;
}

.card-content {
  padding: 12px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-item {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 12px;
  color: rgba(46, 46, 46, 1);
  line-height: normal;

  .label {
    font-weight: 300;
    color: rgba(46, 46, 46, 1);
  }

  .value {
    font-weight: 400;
    color: rgba(46, 46, 46, 1);
  }

  &.info-item-light {
    .label {
      font-weight: 300;
    }

    .value {
      font-weight: 400;
    }
  }
}

.no-data-overlay {
  position: absolute;
  top: 68px;
  /* Below the card-header */
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 1);
  /* Match card background */
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  padding: 12px 20px 20px 20px;

  .no-data-text {
    font-family: 'HarmonyOS Sans SC', sans-serif;
    font-size: 14px;
    color: rgba(46, 46, 46, 0.7);
    text-align: center;
    line-height: normal;
    margin-bottom: 10px;
    /* Adjust as needed */
  }

  .learn-more-btn {
    border: 1px solid rgba(224, 228, 231, 1);
    border-radius: 20px;
    height: 27px;
    width: 93px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 1px;
  }

  .learn-more-link {
    font-family: 'HarmonyOS Sans SC', sans-serif;
    font-size: 12px;
    line-height: 12px;
    color: rgba(46, 46, 46, 1);
    text-decoration: none;
  }
}
</style>
